<template>

  <div class="app-container">

    <!-- 如果是登录页面，则直接渲染 <router-view />，不需要头部、侧边栏、main-content -->
    <LoadingSpinner  />
    <template v-if="isLoginPage">

      <router-view />

    </template>

    <!-- 否则（非登录页面），才渲染头部、侧边栏、main-content -->
    <template v-else>
      <AppHeader :isMobileSidebarVisible="isMobileSidebarVisible" @toggle-mobile-sidebar="toggleMobileSidebar" />
      <div class="layout">
        <AppSidebar :isMobileSidebarVisible="isMobileSidebarVisible" />
        <div class="main-content">
          <router-view />
        </div>
      </div>
    </template>
  </div>

</template>

<script>

import AppHeader from './components/Header.vue';

import AppSidebar from './components/Sidebar.vue';
import LoadingSpinner from "./components/LoadingSpinner.vue";
export default {

  name: 'App',

  components: { AppHeader, AppSidebar, LoadingSpinner },

  data() {

    return {

      isMobileSidebarVisible: false

    };

  },

  computed: {

    isLoginPage() {

      return this.$route && (this.$route.path === '/sign_in'|| this.$route.path === '/set-password' || this.$route.path === '/reset_password' || this.$route.path === '/sign_up' || this.$route.path === '/forgot_password')

    }

  },

  methods: {

    toggleMobileSidebar() {

      this.isMobileSidebarVisible = !this.isMobileSidebarVisible;

    }

  }

};

</script>

<style>
/* 这里 .main-content 的样式依然保留，但只有“非登录页面”时才会出现这个 DOM */

.app-container {

  display: flex;

  flex-direction: column;

  height: 100vh;

}

.layout {

  display: flex;

  flex: 1;

  overflow: hidden;

}

.main-content {

  flex: 1;

  background: #f9fafb;

  padding: 20px;

  overflow: auto;

}
</style>